import { getAuthenticatedUserServer } from "@auth/user/sessionUtils";
import { spaceApiCommunication } from "../clienteSpace";
import {
	IGetComunicacaoNotificacoesRequest,
	IGetComunicacaoNotificacoesResponse,
	IGetComunicacaoQuantidadeNaoLidasResponse,
	IPatchComunicacaoNotificacaoLerRequest,
	IPatchComunicacaoNotificacaoLerResponse,
	IPatchComunicacaoNotificacoesLerTodasResponse,
	IPostComunicacaoNotificacoesRequest,
	IPostComunicacaoNotificacoesResponse,
} from "../dtos/comunication.dto";

// ----------------------------------------------- NOTIFICACOES GERAIS ------------------------------------------------
export function getComunicacaoNotificacoes(req: IGetComunicacaoNotificacoesRequest) {
	const searchParams = new URLSearchParams();
	if (req.limite !== undefined) searchParams.append("limite", req.limite.toString());

	return spaceApiCommunication.get("notificacoes", { searchParams }).json<IGetComunicacaoNotificacoesResponse>();
}

export function getComunicacaoQuantidadeNaoLidas() {
	return spaceApiCommunication
		.get("notificacoes/nao-lidas/quantidade")
		.json<IGetComunicacaoQuantidadeNaoLidasResponse>();
}

export function patchComunicacaoNotificacaoLer(req: IPatchComunicacaoNotificacaoLerRequest) {
	return spaceApiCommunication
		.patch(`notificacoes/${req.id_notificacao}/ler`)
		.json<IPatchComunicacaoNotificacaoLerResponse>();
}

export function patchComunicacaoNotificacoesLerTodas() {
	return spaceApiCommunication.patch("notificacoes/ler-todas").json<IPatchComunicacaoNotificacoesLerTodasResponse>();
}

export function postComunicacaoNotificacoes(req: IPostComunicacaoNotificacoesRequest) {
	const userData = getAuthenticatedUserServer();

	return spaceApiCommunication
		.post("notificacoes", {
			json: {
				...req,
				id_cad_pessoa: userData?.id_cad_pessoa,
				id_cad_pessoa_funcionario: userData?.id_cad_pessoa_funcionario,
			},
		})
		.json<IPostComunicacaoNotificacoesResponse>();
}
